import { useLayoutEffect, useRef } from "react";
import { gsap } from "@/lib/motion";

/**
 * Runs `setup(ctx, scopeEl)` inside a gsap.context scoped to the returned ref,
 * so every tween and ScrollTrigger created inside is reverted on unmount.
 * Prevents orphaned triggers from piling up across client-side route changes.
 *
 * Font-load re-measurement is handled once globally in lib/motion.js. Doing it
 * per instance would fire dozens of ScrollTrigger.refresh() calls on one page.
 */
export function useGsap(setup, deps = []) {
  const scope = useRef(null);

  useLayoutEffect(() => {
    if (!scope.current) return undefined;
    const ctx = gsap.context((self) => setup(self, scope.current), scope);
    return () => ctx.revert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return scope;
}
